
$(function(){
   if($(".js-slick-slider").length){
  $(".js-slick-slider").slick();
}
$(document).on('click', ".ugc-modal", function(e){
  var ev = e || window.event;
  var elem = $(ev.target);
  if(elem.is(".ugc-modal")){
    $(this).hide();
    $("html, body").css('overflow-y', 'auto');
     $("#quick-chat-iframe").addClass('hide');
  }
});
$(document).on('click', ".close-ugc-modal", function(e){
   var modal = $(this).closest('.ugc-modal');
   modal.hide();
   $("html, body").css('overflow-y', 'auto');
   $("#quick-chat-iframe").addClass('hide');
});
$(".product-influencer-item").on("click", function(){
  var index = $(this).attr('data-index');
  $(".influencer-ugc-modal").show();
  if(!$(".js-influencer-slick").hasClass('slicked')){
    $(".js-influencer-slick").slick()
    $(".js-influencer-slick").addClass('slicked');
  }
  $(".js-influencer-slick").slick('slickGoTo', index - 1);
  $("#quick-chat-iframe").addClass('hide');
});
$(document).on('click', ".show-discount-ugc-modal", function(e){
   var modal = $('.discount-ugc-modal');
   if(modal.length){
     modal.show();
     $("html, body").css('overflow-y', 'hidden');
   }
});
$(".index-product-influencer-item").on("click", function(){
  var modal_id = $(this).attr('data-modal-id');
  var influencer_modal = $("#" + modal_id);
  var index = $(this).attr('data-index');
  influencer_modal.show();
  if(!influencer_modal.find(".js-influencer-slick").hasClass('slicked')){
    influencer_modal.find(".js-influencer-slick").slick()
    influencer_modal.find(".js-influencer-slick").addClass('slicked');
  }
  influencer_modal.find(".js-influencer-slick").slick('slickGoTo', index - 1);
  $("#quick-chat-iframe").addClass('hide');
});
});

